'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postConversationClosedEvent = undefined;

var _postExternalApiEvent = require('../../external-api-events/actions/postExternalApiEvent');

var _externalApiEventTypes = require('../../external-api-events/constants/externalApiEventTypes');

var _serializeThreadForExternalEvent = require('../../external-api-events/util/serializeThreadForExternalEvent');

var postConversationClosedEvent = exports.postConversationClosedEvent = function postConversationClosedEvent(_ref) {
  var thread = _ref.thread;
  return function (dispatch) {
    dispatch((0, _postExternalApiEvent.postExternalApiEvent)({
      eventType: _externalApiEventTypes.CONVERSATION_CLOSED,
      payload: {
        conversation: (0, _serializeThreadForExternalEvent.serializeThreadForExternalEvent)(thread)
      }
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/threads/actions/postConversationClosedEvent.js
// module id = 427
// module chunks = 2 3